import { Component } from '@angular/core';
import { Card } from 'primeng/card';
import { Skeleton } from 'primeng/skeleton';

@Component({
	selector: 'loading-component',
	imports: [Card, Skeleton],
	template: `
		<p-card styleClass="search-box w-100">
			<div class="ui-g">
				<div class="ui-g-12 ui-lg-12 ui-md-12">
					<p-skeleton width="100%" height="2rem"></p-skeleton>
				</div>

				<div class="ui-g-6 ui-lg-6 ui-md-6">
					<p-skeleton width="100%" height="150px"></p-skeleton>
				</div>
				<div class="ui-g-6 ui-lg-6 ui-md-6">
					<p-skeleton width="100%" height="150px"></p-skeleton>
				</div>
			</div>
		</p-card>
	`,
})
export class LoadingComponent {}
